import { RefString, RefBool } from "@tblabs/truffle";
import { RawTab } from "./RawTab";

export class Tab
{
    public Id = new RefString();
    public Icon = new RefString();
    public Label = new RefString();
    public IsVisible = new RefBool(true);

    constructor(raw?: Partial<RawTab>)
    {
        this.Id.value = raw?.Id || "";
        this.Icon.value = raw?.Icon || "";
        this.Label.value = raw?.Label || "default";
        this.IsVisible.value = raw?.IsVisible || false;
    }
}
